module.exports = __webpack_public_path__ + "img/tc.ef4dfe2e.svg";